import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-update-confirmation-dialog',
    templateUrl: './update-confirmation-dialog.component.html',
    styleUrls: ['./update-confirmation-dialog.component.scss'],
    standalone: false
})
export class UpdateConfirmationDialog {
  constructor(
    public dialogRef: MatDialogRef<UpdateConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { action: string; count: number }
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}